import { render, staticRenderFns } from "./Clipboard.vue?vue&type=template&id=3f9fa554&"
import script from "./Clipboard.vue?vue&type=script&lang=ts&"
export * from "./Clipboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports